import breakpoints from './breakpoints.json';
import { defaultColors as colors } from './colors';
// ToDo: Rewrite this
//import { getSpacingConfig } from './space';
import { THEMES as themes } from './presets/themes';
import { BORDER_WIDTHS, BORDER_RADII } from './presets/border';

export const Theme = {
  breakpoints,
  colors,
  fontFamily: 'sans-serif',
  fontSize: {
    'heading-lg': '28px',
    'heading-md': '24px',
    'heading-sm': '20px',
    'button-lg': '16px',
    'button-md': '14px',
    'button-sm': '12px',
    'text-lg': '16px',
    'text-md': '14px',
    'text-sm': '12px',
  },
  //getSpacingConfig,
  themes,
  border: {
    BORDER_RADII,
    BORDER_WIDTHS,
  },
};
